import React from 'react';

const VoucherErrorBanner = ({supplierError = 'warning', bannerType}) => {
  return (
    <>
    {supplierError?.responseCode !== "600" && 
    <div className={bannerType === 'error' ? 'stepper-error-message' : 'stepper-warning-message'}>
        {/* invalid-modal__body */}
          <div className="">
            {supplierError?.responseDescription}            
          </div>
      </div>}
      </>
  );
};

export default VoucherErrorBanner;
